/**
 * Per-route SEO metadata registry for public marketing pages.
 * Consumed by <RouteSeo/> (components/SeoHead.jsx), mounted once in
 * App.jsx. Routes not listed (the authenticated app) are untouched.
 * Rules: title <= 60 chars, description <= 155, category-first, no
 * competitor or AI-vendor names.
 */
export const SEO_META = {
  '/': {
    title: 'Markaii — AI Marketing Operating System for SaaS Founders',
    description:
      'Markaii plans each brand\'s marketing, drafts platform-native content, routes it through your approval queue, publishes to Instagram, Facebook, X, LinkedIn, and TikTok, and learns from engagement.',
  },
  '/pricing': {
    title: 'Markaii Pricing — Solo $79, Pro $249, Agency $599',
    description:
      'AI marketing operating system pricing: Solo $79/month (1 brand), Pro $249/month (3 brands), Agency $599/month (10 brands). Annual saves two months. 14-day free trial.',
  },
  '/signup': {
    title: 'Start Your Free Trial — Markaii',
    description:
      'Create your Markaii account and put a brand\'s marketing on autopilot — plan, content, approvals, and publishing for 14 days free.',
  },
  '/login': {
    title: 'Sign in — Markaii',
    description: 'Sign in to your Markaii dashboard.',
  },
  '/privacy': {
    title: 'Markaii Privacy Policy',
    description: 'How Markaii collects, uses, and protects data across connected social accounts and brands.',
  },
  '/terms': {
    title: 'Markaii Terms of Service',
    description: 'The terms that govern Markaii subscriptions, billing, and acceptable use.',
  },
};
